import createStore from "@Stores/base-factories"
import { hookAllocationList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('site')
  .extend(hookAllocationList())
  .factory()

export {
  Provider as SettingProvider,
  useStore as useSettingStore,
}
